/** Browser tab title when no company name is configured. */
export function marketplaceDocumentTitle(companyName) {
  const name = (companyName || '').trim();
  return name ? `${name}: Marketplace` : 'Marketplace';
}

function faviconType(logoUrl) {
  if (logoUrl.startsWith('data:image/svg')) return 'image/svg+xml';
  if (logoUrl.startsWith('data:image/png')) return 'image/png';
  if (logoUrl.startsWith('data:image/jpeg') || logoUrl.startsWith('data:image/jpg')) return 'image/jpeg';
  return null;
}

/** Set or clear the tab favicon from the uploaded company logo data URI. */
export function applyFavicon(logoUrl) {
  const existing = document.querySelector("link[data-brand-favicon='true']");

  if (logoUrl) {
    let link = existing;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.setAttribute('data-brand-favicon', 'true');
      document.head.appendChild(link);
    }
    link.href = logoUrl;
    const type = faviconType(logoUrl);
    if (type) link.type = type;
    else link.removeAttribute('type');
  } else if (existing) {
    existing.remove();
  }
}

export function applyBrandingDocument({ companyName, logoUrl }) {
  document.title = marketplaceDocumentTitle(companyName);
  applyFavicon(logoUrl);
}
